if(!customElements.get('swatch-hover-component')) {
  customElements.define(
    'swatch-hover-component',
    class SwatchHoverComponent extends HTMLElement {
      constructor() {
        super();
        this.image = null;
        this.swatchItems = [];
        this.preloadedImages = new Map();
        this.lastTappedSwatch = null;
        this.boundHandleSwatchHover = this.handleSwatchHover.bind(this);
        this.boundHandleSwatchTap = this.handleSwatchTap.bind(this);
      }

      connectedCallback() {
        setTimeout(() => this.init(), 100);
      }

      init() {
        this.image = this.querySelector('.swatch-hover-image');
        this.imageContainer = this.querySelector('.recommended-products__product__img-container') || this.querySelector('.card__media');
        this.swatchItems = this.querySelectorAll('.swatch-hover-item');
        
        //Detect section type
        this.isFeaturedCollection = this.dataset.sectionName === 'featured-collection' || this.dataset.sectionName === 'main-collection';
        
        // Select title element and product link based on structure
        if (this.isFeaturedCollection) {
          this.titleElement = this.querySelector('.card__heading.h5 a') || this.querySelector('.card__heading a');
          this.productLink = this.titleElement;
        } else {
          this.titleElement = this.querySelector('.card__heading');
          this.productLink = this.querySelector('.recommended-products__product__link');
        }
        
        if (this.isFeaturedCollection) {
          // Card-product structure (featured-collection)
          this.priceWrapper = this.querySelector('div.price');
          this.priceContainer = this.querySelector('.price__container');
          this.priceRegularDiv = this.querySelector('.price__regular');
          this.priceSaleDiv = this.querySelector('.price__sale');
          this.regularPriceSpan = this.querySelector('.price__regular .price-item--regular');
          this.salePriceSpan = this.querySelector('.price__sale .price-item--last');
          this.compareAtPriceSpan = this.querySelector('.price__sale s.price-item--regular');
        } else {
          // Simple structure (product-recommendations/recently-viewed)
          this.price = this.querySelector('.remove-spacing.price');
          this.compareAtPrice = this.querySelector('.remove-spacing.compare-at-price');
        }
        
        if (!this.image || this.swatchItems.length === 0) return;
        
        // Preload all swatch images
        this.preloadSwatchImages();
        
        // Add hover and tap listeners to each swatch item
        this.swatchItems.forEach(item => {
          item.addEventListener('mouseenter', this.boundHandleSwatchHover);
          item.addEventListener('click', this.boundHandleSwatchTap);
        });
      }

      preloadSwatchImages() {
        this.swatchItems.forEach(item => {
          const imageUrl = item.dataset.imageUrl;
          if (imageUrl && !this.preloadedImages.has(imageUrl)) {
            const img = new Image();
            img.src = imageUrl;
            this.preloadedImages.set(imageUrl, img);
          }
        });
      }

      handleSwatchHover(event) {
        const swatchItem = event.currentTarget;
        this.updateSwatchDisplay(swatchItem);
      }

      handleSwatchTap(event) {
        const swatchItem = event.currentTarget;
        
        // Detect if it's a touch device
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        
        // Desktop (hover mode): single click navigates
        if (!isTouchDevice) {
          this.updateSwatchDisplay(swatchItem);
          return; // Allow navigation
        }
        
        // Mobile (touch mode): double tap to navigate
        if (this.lastTappedSwatch === swatchItem) {
          return; // Second tap - allow navigation
        }
        
        // First tap: prevent navigation and update display
        event.preventDefault();
        this.lastTappedSwatch = swatchItem;
        this.updateSwatchDisplay(swatchItem);
      }

      updateSwatchDisplay(swatchItem) {
        const imageUrl = swatchItem.dataset.imageUrl;
        const title = swatchItem.dataset.title;
        const price = swatchItem.dataset.price;
        const compareAtPrice = swatchItem.dataset.compareAtPrice > 0 ? swatchItem.dataset.compareAtPrice : null;
        const productUrl = swatchItem.getAttribute('href');
        
        if (!imageUrl) return;
        
        // Remove active class from all swatch items
        this.swatchItems.forEach(item => item.classList.remove('active'));
        
        // Add active class to current item
        swatchItem.classList.add('active');
        
        // Update image immediately (already preloaded)
        this.image.src = imageUrl;
        this.image.srcset = '';

        // Update the title text first
        if (title && this.titleElement) {
          this.titleElement.textContent = title;
        }

        // Update product link href after title update
        if (productUrl && this.productLink) {
          this.productLink.setAttribute('href', productUrl);
        }
        
        // Update price based on section structure
        if (this.isFeaturedCollection) {
          // Card-product structure logic
          if (compareAtPrice && this.priceWrapper) {
            // Current swatch has compare at price - switch to sale view
            this.priceWrapper.classList.add('price--on-sale');
            
            if (this.compareAtPriceSpan) {
              this.compareAtPriceSpan.textContent = formatMoney(this.addCommas(compareAtPrice));
            }
            if (this.salePriceSpan) {
              this.salePriceSpan.textContent = formatMoney(this.addCommas(price));
            }
          } else if (this.priceWrapper) {
            // Current swatch has no compare at price - switch to regular view
            this.priceWrapper.classList.remove('price--on-sale');
            
            if (this.regularPriceSpan) {
              this.regularPriceSpan.textContent = formatMoney(this.addCommas(price));
            }
          }
        } else {
          // Simple structure logic
          if (price && this.price) {
            this.price.textContent = formatMoney(this.addCommas(price));
          }
          if (compareAtPrice && this.compareAtPrice) {
            this.compareAtPrice.classList.remove('hidden');
            this.compareAtPrice.textContent = formatMoney(this.addCommas(compareAtPrice));
          } else if (this.compareAtPrice && !compareAtPrice) {
            this.compareAtPrice.classList.add('hidden');
          }
        }
      }

      addCommas(num) {
        return parseFloat(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      disconnectedCallback() {
        this.swatchItems.forEach(item => {
          item.removeEventListener('mouseenter', this.boundHandleSwatchHover);
          item.removeEventListener('click', this.boundHandleSwatchTap);
        });
        this.preloadedImages.clear();
      }
    }
  );
}
